import { SignedIn, SignedOut, UserButton, useAuth } from '@clerk/nextjs';
import { BikeIcon, CogIcon } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { SignInDialog } from '../closed-beta-dialog';

export function UserNav() {
  const t = useTranslations('Profile');
  const { has } = useAuth();
  const isAdmin = has?.({ role: 'org:admin' });

  return (
    <>
      <SignedIn>
        <UserButton>
          {isAdmin && (
            <UserButton.MenuItems>
              <UserButton.Link
                label="Administration"
                labelIcon={<CogIcon size={16} />}
                href="/admin"
              />
            </UserButton.MenuItems>
          )}
          <UserButton.MenuItems>
            <UserButton.Link
              label={t('Mes aventures')}
              href="/adventures"
              labelIcon={<BikeIcon size={16} />}
            />
          </UserButton.MenuItems>
        </UserButton>
      </SignedIn>
      <SignedOut>
        <SignInDialog />
      </SignedOut>
    </>
  );
}
